import React from 'react';
import styled from 'styled-components';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const TrackingDemo = () => {
  return (
    <Container>
      <DotLottieReact
        src="https://lottie.host/08ee8761-943f-490d-9c8f-bd0a974a78db/24u2R4pxCa.lottie"
        loop
        autoplay
      />
    </Container>
  );
};

export default TrackingDemo; 